import { BuyerTypesWrapper } from "../../components";

export default function BuyerTypesPage() {
  return <BuyerTypesWrapper />;
}
